// extracted by mini-css-extract-plugin
module.exports = {"webcamMirror":"webcamMirror_webcamMirror__2oI7F","content":"webcamMirror_content__3ll7Y","hidden":"webcamMirror_hidden__30sOQ"};